import { openDB, type IDBPDatabase } from 'idb'

const DB_NAME = 'meshinator'
const DB_VERSION = 4

export const USER_CLIPS_STORE = 'user-clips'
export const CUSTOM_SKELETONS_STORE = 'custom-skeletons'
export const PROJECT_SESSIONS_STORE = 'project-sessions'
export const POSES_STORE = 'poses'

let db_promise: Promise<IDBPDatabase> | null = null

export function get_db (): Promise<IDBPDatabase> {
  if (db_promise === null) {
    db_promise = openDB(DB_NAME, DB_VERSION, {
      upgrade (db, old_version) {
        if (old_version < 1) {
          db.createObjectStore(USER_CLIPS_STORE, { keyPath: 'skeleton_type' })
        }
        if (old_version < 2) {
          db.createObjectStore(CUSTOM_SKELETONS_STORE, { keyPath: 'id' })
        }
        if (old_version < 3) {
          db.createObjectStore(PROJECT_SESSIONS_STORE, { keyPath: 'id' })
        }
        if (old_version < 4) {
          db.createObjectStore(POSES_STORE, { keyPath: 'id' })
        }
      }
    })
  }
  return db_promise
}
